import { Box } from "@mui/material";
import { Custom, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { forwardRef } from "react";
import { createStep } from "utils/helpers";

const StepMessage = forwardRef(() => {
  const { updateData, data } = useWorkflow<Workflow.Utils.PotluckType>(); // Include updateData and potluck
  const { theme } = useTheme();
  const { t } = useApp();

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.potluck.start_potluck}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
          {t.component.workflow.potluck.message_invite}
        </Custom.Typography>
      </Box>

      <Box mt={theme.spacing.md}>
        <Custom.TextField
          sx={{ mt: 0 }}
          placeholder={t.placeholder.message_guests}
          multiline
          rows={4}
          fullWidth
          value={data.potluck.message || ""} // Bind to potluck context
          onChange={(e) => updateData("potluck.message", e.target.value)} // Update potluck state
        />
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.PotluckType>(StepMessage);
